import React from 'react'

const Footer = () => {
  return (
    <div>
      <footer className='footer text-white '>
        <div className='container'>
          <footer className='py-3'>
            <div className='row '>
              <div className='col-12'>
                <div className="row text-center mt-2">
                  <div className="col-sm-3">
                    <i className='fa fa-volume-control-phone fa-2x mb-2'></i>
                    <h5 className=' fw-bold'>Contatc Number</h5>
                    <p>+91 9123456778</p>
                    <p>+91 8223456778</p>
                  </div>
                  <div className="col-sm-3">
                    <i className="fa fa-map-marker fa-2x mb-2" ></i>
                    <h5 className=' fw-bold'>Our Address</h5>
                    <p>bangalore,india-530068</p>
                  </div>
                  <div className="col-sm-3">
                   
                    <i className="fa fa-hourglass-end fa-2x mb-2"></i>
                    <h5 className=' fw-bold'>Opening Hours</h5>
                    <p>7.00 AM-10.00 PM</p>
                  </div>
                  <div className="col-sm-3">
                    <i className="fa fa-envelope fa-2x mb-2" ></i>
                    <h5 className=' fw-bold'>Our Email</h5>
                    <p>dentalcare@gmail.com</p>
                    <p>gandhiraj007p@gmail.com</p>
                  </div>
                </div>
              </div>
              <hr />
              <div className='col-12 d-flex justify-content-center'>
                <p>Gandhiraj@copyright</p>
              </div>
            </div>
          </footer>
        </div>
      </footer>
    </div>
  )
}

export default Footer